import { Stack } from '@mui/material'
import FunctionButton from './FunctionButton'
import { usePermission } from '@/hooks/permissions'
import useTranslation from '@/hooks/useTranslation'
interface FunctionButtonBarProps {
  onFunction: () => void
  offFunction: () => void
  pingFunction: () => void
  autoswitchFunction: () => void
  isLoading: any
  isHideAutoSwitch?: boolean
}

const FunctionButtonBar = ({
  onFunction,
  offFunction,
  pingFunction,
  autoswitchFunction,
  isLoading,
  isHideAutoSwitch
}: FunctionButtonBarProps) => {
  const { t } = useTranslation()
  const { isViewOnly } = usePermission()
  return (
    <Stack direction="row" spacing="10px">
      <FunctionButton
        onClick={onFunction}
        isLoading={isLoading}
        text={t('mapViewStationOn')}
        disable={isLoading || isViewOnly}
        sx={{ opacity: isViewOnly ? 0.6 : 1,
          minWidth: '56px',
         }}
      />
      <FunctionButton
        onClick={offFunction}
        isLoading={isLoading}
        text={t('mapViewStationOff')}
        sx={{
          opacity: isViewOnly ? 0.6 : 1,
          backgroundColor: '#8A8A8A',
          minWidth: '56px',
          '&:hover': {
            backgroundColor: '#8A8A8A',
          },
        }}
        disable={isViewOnly||isLoading}
      />
      <FunctionButton
        onClick={pingFunction}
        isLoading={isLoading}
        text={t('mapViewStationsPing')}
        sx={{
          opacity: isViewOnly ? 0.6 : 1,
          backgroundColor: '#FF783C',
          minWidth: '40px',
          '&:hover': {
            backgroundColor: '#FF783C',
          },
        }}
        disable={isViewOnly||isLoading}
      />
      {!isHideAutoSwitch && <FunctionButton
        onClick={autoswitchFunction}
        isLoading={isLoading}
        text={t('Autoswitch')}
        sx={{
          opacity: isViewOnly ? 0.6 : 1,
          backgroundColor: '#29AAE1',
          '&:hover': {
            backgroundColor: '#29AAE1',
          },
        }}
        disable={isViewOnly||isLoading}
      />}
    </Stack>
  )
}

export default FunctionButtonBar
